<template>
    <v-container class="my-5">
        <!--   Diálogo para Mostrar un mensaje al Eliminar Estudiante     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="500"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_estudiante')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>

                    <v-btn
                            color="primary"
                            @click="deleteStudent()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
        <v-dialog v-model="dialogImageProfile" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfileURL"
                            ref="clipperImageProfile"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfile()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{ $t('my_family') }}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="350px">
                <template v-slot:activator="{ on }">
                    <v-btn
                            color="primary"
                            dark
                            v-on="on"
                            @click="update = false,
                                cleanFields()"> + {{ $t('agregar_hijo') }}
                    </v-btn>
                </template>
                <ValidationObserver v-slot="{ invalid, reset }" ref="observer">
                <v-form
                        @submit.prevent="update
                        ? updateStudent(id_update)
                        : createStudent()">

                      <v-card class="elevation-5">
                          <v-toolbar dark color="primary">
                              <v-toolbar-title>
                                  {{ $t('hijo') }}
                              </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-btn
                                      class="align-self-end"
                                      color="red"
                                      icon
                                      @click="clear(), dialog = false">
                                  <v-icon>mdi-close</v-icon>
                              </v-btn>
                          </v-toolbar>
                          <v-card-text class="text-center">
                              <v-flex class="pt-3 pb-3 pl-3 pr-3">
                                  <v-label>
                                      {{$t('foto_perfil')}}
                                  </v-label>
                                  <br>
                                  <v-avatar
                                          class="profile"
                                          color="grey"
                                          size="200"
                                  >
                                      <v-img :src="resultProfileURL"
                                             v-if="resultProfileURL"
                                      >
                                      </v-img>
                                  </v-avatar>
                                  <br>
                                  <v-alert
                                          v-if="errores.avatar"
                                          type="error"
                                          outlined
                                          transition="scale-transition"
                                  >
                                      {{errores.avatar}}
                                  </v-alert>
                                  <br>
                                  <v-btn
                                          color="primary">
                                      <clipper-upload
                                              @input="dialog = false, dialogImageProfile = true, degrees = 0"
                                              accept="image/*"
                                              v-model="imageProfileURL"
                                      >
                                          {{$t('subir_imagen')}}
                                      </clipper-upload>
                                  </v-btn>
                              </v-flex>
                              <ValidationProvider :rules="'required'" v-slot="{ errors }">
                                <v-autocomplete
                                    v-model="section"
                                    :placeholder="$t('placeholder_choose_school')"
                                    prepend-icon="mdi-home-city"
                                    name="section"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('Escuelas')"
                                    :items="sections"
                                    :error-messages="errors[0]"
                                    no-data-text="Ningún Resultado"
                                    clearable
                                >
                                  <template v-slot:selection="data">
                                    <v-chip
                                        v-bind="data.attrs"
                                        :input-value="data.selected"
                                        @click="data.select"
                                    ><v-avatar>
                                      <img :src="data.item.logo"/>
                                    </v-avatar>
                                      {{ data.item.name }}
                                    </v-chip>
                                  </template>
                                  <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                      <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                      <v-list-item-avatar>
                                        <img :src="data.item.logo"/>
                                      </v-list-item-avatar>
                                      <v-list-item-content>
                                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                      </v-list-item-content>
                                    </template>
                                  </template>
                                </v-autocomplete>
                              </ValidationProvider>
                              <ValidationProvider :rules="'required'" v-slot="{ errors }">
                                <v-text-field
                                    v-model="first_name"
                                    autofocus
                                    prepend-icon="mdi-account"
                                    name="first_name"
                                    :label="$t('Nombre')"
                                    :error-messages="errors[0]"
                                >
                                </v-text-field>
                              </ValidationProvider>
                              <ValidationProvider :rules="'required'" v-slot="{ errors }">
                                <v-text-field
                                    v-model="last_name"
                                    prepend-icon="mdi-account-outline"
                                    name="last_name"
                                    :label="$t('Apellido')"
                                    :error-messages="errors[0]"
                                >
                                </v-text-field>
                              </ValidationProvider>
                              <v-alert
                                      :value=alerta
                                      type="warning"
                                      outlined
                                      transition="scale-transition"
                              >
                                  Fallo con el Servidor
                              </v-alert>
                              <small class="red--text text--lighten-1">{{$t('msg_add_students')}}</small>
                          </v-card-text>
                          <v-card-actions>
                              <v-btn
                                      color="primary"
                                      @click="clear(),
                                              dialog = false"
                              >{{$t('cerrar')}}
                              </v-btn>
                              <v-spacer/>
                              <v-btn
                                      :loading="loading"
                                      v-if="update"
                                      color="primary"
                                      type="submit"
                              >{{$t('modificar')}}
                              </v-btn>
                              <v-btn
                                      :loading="loading"
                                      v-else
                                      color="primary"
                                      :disabled="invalid || resultProfileURL === ''"
                                      type="submit"
                              >{{$t('agregar')}}
                              </v-btn>
                          </v-card-actions>
                      </v-card>
                </v-form>
                </ValidationObserver>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" calign-center>
            <v-flex>
                <v-card class="elevation-5">
                    <v-card-text>
                        <v-layout row wrap class="my-4" calign-center justify-center fill-height>
                            <v-flex xs12>
                                <v-data-table
                                        :headers="headers"
                                        :loading="loading_data_students"
                                        :items="students"
                                        :search="search"
                                        hide-default-footer
                                        class="elevation-1"
                                        :items-per-page="-1"
                                >
                                    <template v-slot:items="props">
                                        <td>{{ props.item.id }}</td>
                                        <td>{{ props.item.first_name }}</td>
                                        <td>{{ props.item.last_name }}</td>
                                    </template>
                                    <template v-slot:item.avatar="{ item }">
                                      <v-avatar
                                              class="profile"
                                              color="grey"
                                              size="50"
                                      >
                                          <v-img :src="item.avatar">
                                          </v-img>
                                      </v-avatar>
                                    </template>
                                    <template v-slot:item.classroom="{ item }">
                                      <div v-if="item.classroom === null"
                                        class="red--text text--lighten-1"
                                      >
                                        {{$t('no_group_assigned_yet')}}
                                      </div>
                                      <div v-else-if="item.classroom === 'Validación en progreso'"
                                        class="red--text text--lighten-1"
                                      >
                                        {{$t('validation_in_progress')}}
                                      </div>
                                      <div v-else>
                                        {{item.classroom}}
                                      </div>
                                    </template>
                                    <template v-slot:no-results>
                                        <v-alert type="warning">
                                            {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                                        </v-alert>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import {mapState} from 'vuex'
import Vue from 'vue'
import { required } from 'vee-validate/dist/rules'

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})

extend('required', {
  ...required,
  message: 'This field is required'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'my_family',
  created: function () {
    this.getStudents()
    this.getPreregisters()
  },
  data: () => ({
    show: false,
    alerta: false,
    dialog: false,
    update: false,
    id_update: 0,
    first_name: '',
    last_name: '',
    errores: [],
    headers: [],
    students: [],
    tutors: [],
    loading_data_students: false,
    confirmation: '',
    search: '',
    // Imágenes
    dialogImageProfile: false,
    imageProfileURL: '',
    resultProfileURL: '',
    resultAuxProfileURL: '',
    // Delete Manager
    deleteDialog: false,
    idStudentDelete: 0,
    idTutor1: null,
    idTutor2: null,
    loading: false,
    classrooms: [],
    section: '',
    sections: [
      {
        "id": "2da06199-3b24-49fd-88c1-29e2e1fc0f09",
        "name": "Apostólica Kinder",
        "logo": "https://intrareesc.s3.amazonaws.com/static/Logos/logo_updatef48c978c-ca3d-421b-826f-1b1c26bf495c.jpeg",
        "url_map": "https://www.google.com/maps/place/Apost%C3%B3lica/@22.1852905,-101.075905,12z/data=!4m8!1m2!2m1!1sapost%C3%B3lica!3m4!1s0x842aa276aba23f2d:0x742f097c6e67ef1d!8m2!3d22.1217769!4d-100.9747239"
      },
      {
        "id": "a42aab80-6cf2-40fb-8fd3-0f4c25de6076",
        "name": "Apostólica Primaria",
        "logo": "https://intrareesc.s3.amazonaws.com/static/Logos/logoc9d7329c-07cc-4885-8c59-793610625b7e.jpeg",
        "url_map": "https://goo.gl/maps/gxJan9R8vMXxsvoW6"
      },
      {
        "id": "8a68a3fd-753e-4bb4-9776-a411d1b541ac",
        "name": "Apostólica Secundaria",
        "logo": "https://intrareesc.s3.amazonaws.com/static/Logos/logoc9d7329c-07cc-4885-8c59-793610625b7e.jpeg",
        "url_map": "https://goo.gl/maps/gxJan9R8vMXxsvoW6"
      },
      {
        "id": "114ed780-6ed9-4a32-bdaf-65aaa56e8011",
        "name": "Fidel Ferrer",
        "logo": "https://intrareesc.s3.amazonaws.com/static/Logos/logo_update41aa694c-56ac-4346-a9fb-3f93ee21ada4.jpeg",
        "url_map": "https://www.google.com/maps/place/22%C2%B009'03.5%22N+101%C2%B001'18.8%22W/@22.1509835,-101.0227753,18z/data=!3m1!4b1!4m5!3m4!1s0x0:0x0!8m2!3d22.1509815!4d-101.0218813"
      }
    ],
    idClassroom: null,
    idClassroomStudent: null,
    degrees: 0,
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('photo'),
        align: 'center',
        sortable: false,
        value: 'avatar'
      },
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'last_name'
      },
      {
        text: this.$t('grade'),
        align: 'left',
        sortable: true,
        value: 'classroom'
      }
    ]
  },
  computed: {
    ...mapState(['language'])
  },
  methods: {
    getStudents () {
      this.loading_data_students = true
      HTTP.get('student/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.students = response.data
        this.loading_data_students = false
      })
      .catch(e => {
        console.log(e)
        this.loading_data_students = false
      })
    },
    getPreregisters () {
      HTTP.get('preregistration/list/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        let preregisters = response.data
        if (preregisters.length > 0) {
          for(let k = 0; k < preregisters.length; k++)
          if(preregisters[k].student.length > 0) {
            for(let i = 0; i < preregisters[k].student.length; i++) {
              // console.log(preregisters[0].student[i].first_name)
              // console.log(preregisters[0].student[i].last_name)
              // console.log(preregisters[0].student[i].avatar)
              let editedItem = {
                idSchool: '',
                first_name: preregisters[k].student[i].first_name,
                last_name: preregisters[k].student[i].last_name,
                avatar: preregisters[k].student[i].avatar,
                classroom: 'Validación en progreso'
              }
              this.students.push(editedItem)
            }
          }

        }
      })
      .catch(e => {
        console.log(e)
      })
    },
    example: item => (item.grade_name === null ? 'n/a' : item.grade_name) + ' ' + (item.name === null ? 'n/a' : item.name),
    customFilterHouse (item, queryText) {
      var text = ''
      if (item.grade_name === null || item.grade_name === '') {
        text = 'n/a'
      } else {
        text = item.grade_name.toLowerCase()
      }
      if (item.name === null || item.name === '') {
        text += ' n/a'
      } else {
        text +=  ' ' +  item.name.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    idClassroomFilter (value) {
      // If this filter has no value we just skip the entire filter.
      if (this.idClassroom === null || this.idClassroom === undefined) {
        return true
      }
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      else {
        if (value === null)
          return value
        else
          return value.toLowerCase().includes(this.idClassroom.toLowerCase())
      }
    },
    createStudent () {
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      var fileImageProfile = null

      bodyFormData.set('student[0]first_name', this.first_name)
      bodyFormData.set('student[0]last_name', this.last_name)
      bodyFormData.set('student[0]idSchool', this.section)
      if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
        const newID = this.$uuid.v4()
        fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar' + newID + '.jpeg')
      }
      bodyFormData.append('student[0]avatar', fileImageProfile)
      HTTP.post('student_by_tutor/', bodyFormData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        this.loading = false
        console.log(ok)
        this.getStudents()
        this.getPreregisters()
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_hijo_alta'))
        this.dialog = false
        setTimeout(this.clear, 3000)
      })
      .catch(e => {
        this.loading = false
        if (e.response.status === 400 && typeof e.response.data === 'object' && e.response.data) {
          if (e.response.data) {
            this.errores = e.response.data
          }
        }
      })
    },
    updateStudent (id) {
      // console.log('ID Student = ', id)
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      var fileImageProfile = null
      if (this.idTutor1 === undefined) {
        this.idTutor1 = null
      }
      if (this.idTutor2 === undefined) {
        this.idTutor2 = null
      }
      if (this.idClassroomStudent === undefined) {
        this.idClassroomStudent = null
      }
      if (this.resultProfileURL !== this.resultAuxProfileURL) {
        const newID = this.$uuid.v4()
        if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
          fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar' + newID + '.jpeg')
        }
        bodyFormData.append('avatar', fileImageProfile)
      }
      bodyFormData.set('first_name', this.first_name)
      bodyFormData.set('last_name', this.last_name)
      bodyFormData.set('idClassroom', this.idClassroomStudent)
      bodyFormData.set('idTutor1', this.idTutor1)
      bodyFormData.set('idTutor2', this.idTutor2)
      HTTP.patch('student/' + id, bodyFormData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        this.loading = false
        console.log(ok)
        this.getStudents()
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_estudiante_modificado'))
        this.dialog = false
        setTimeout(this.clear, 3000)
      })
      .catch(e => {
        this.loading = false
        if (e.response.status === 400 && typeof e.response.data === 'object' && e.response.data) {
          if (e.response.data) {
            this.errores = e.response.data
          }
        }
      })
    },
    deleteStudent () {
      HTTP.delete('student/' + this.idStudentDelete, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        // console.log('Manager con ID = ', this.idStudentDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_estudiante_eliminado'))
        this.getStudents()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
      .catch(e => {
        if (e.response.status === 400 && typeof e.response.data === 'object' && e.response.data) {
          this.errores = e.response.data
        }
      })
    },
    clear () {
      this.alerta = false
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    fillFields (item) {
      this.first_name = item.first_name
      this.last_name = item.last_name
      this.idTutor1 = item.idTutor1
      this.idTutor2 = item.idTutor2
      if(item.unique_number === null)
        this.$store.commit('setRFID', '')
      else
        this.$store.commit('setRFID', item.unique_number)
      this.idClassroomStudent = item.idClassroom
      this.resultProfileURL = item.avatar
      this.resultAuxProfileURL = item.avatar
    },
    customFilter (item, queryText) {
      const textOne = item.first_name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    cleanFields () {
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
      this.first_name = ''
      this.last_name = ''
      this.resultProfileURL = ''
      this.section = ''
    },
    getCutingProfile () {
      const canvas = this.$refs.clipperImageProfile.clip() // call component's clip method
      this.resultProfileURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      this.dialogImageProfile = false
      this.dialog = true
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #00A1E4 #00A1E4 #00A1E4 #00A1E4;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
    .wrapper{
        width:200px;
        height:200px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #00A1E4;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
    .splash-info {
        background: #ffffff;
        position: relative;
        z-index: 2;
        margin-bottom: 30px;
        text-align: center;
        font-size:15px;
        font-weight:bold;
    }
</style>
